import { render, staticRenderFns } from "./ImagePlaceholderSvg.vue?vue&type=template&id=067d2caf&scoped=true&"
import script from "./ImagePlaceholderSvg.vue?vue&type=script&lang=js&"
export * from "./ImagePlaceholderSvg.vue?vue&type=script&lang=js&"
import style0 from "./ImagePlaceholderSvg.vue?vue&type=style&index=0&id=067d2caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d2caf",
  null
  
)

export default component.exports